<div id="sGaleria">
  <div *ngIf="images" class="container">
    <div class="flex flex-wrap">
      <!-- <p-galleria
        [value]="images"
        [(visible)]="displayCustom"
        [(activeIndex)]="activeIndex"
        [responsiveOptions]="responsiveOptions"
        [containerStyle]="{ 'max-width': '850px' }"
        [numVisible]="10"
        [circular]="true"
        [fullScreen]="true"
        [showItemNavigators]="true"
        [showThumbnails]="false"
        [baseZIndex]="100000">
        <ng-template pTemplate="item" let-item>
          <img [src]="item.previewImageSrc" alt="Image" />
        </ng-template>
        <ng-template pTemplate="thumbnail" let-item>

          <div class="grid grid-nogutter justify-content-center">
            <img [src]="item.thumbnailImageSrc" alt="Image" />
          </div>
        </ng-template>
      </p-galleria> -->

      <!-- [showTransitionOptions]="'1000ms cubic-bezier(0, 0, 0.2, 1)'" -->
      <p-galleria
        [value]="images"
        [autoPlay]="true"
        [numVisible]="1"
        [circular]="true"
        [transitionInterval]="4000"
        [showItemNavigators]="false"
        [showThumbnails]="false"
        [showIndicatorsOnItem]="true"
        [showIndicators]="false"
        verticalThumbnailViewPortHeight="300">
        <!-- [responsiveOptions]="responsiveOptions" -->
        <ng-template pTemplate="item" let-item>
          <img [src]="item.previewImageSrc" [attr.alt]="item.alt" />
        </ng-template>
        <ng-template pTemplate="caption" let-item>
          <a href=" {{ item.href }}">
            <div class="title">
              {{ item.title }}
            </div>
            <div class="subtitle">{{ item.subtitle }}</div>
          </a>
        </ng-template>
      </p-galleria>

      <!-- <div *ngIf="images" class="grid image-list justify-content-center">
        <div
          *ngFor="let image of images; let index = index"
          class="col-12 sm:col-6 md:col-4 lg:col-4"
          key="index">
          <img
            [src]="image.thumbnailImageSrc"
            [alt]="image.alt"
            style="cursor: pointer"
            (click)="imageClick(index)"
            (keyup)="imageClick(index)"
            tabindex="0" />
        </div>
      </div> -->
    </div>
  </div>
</div>
